import { Injectable, inject } from '@angular/core';
import { isArray } from 'lodash';
import { UnitsV2 } from '@schenck/rotec-components';
import { RotorTypeStatuses } from 'src/utils/enums/rotor-type.enum';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import {
  Attachment,
  LaserLinesStatus,
  RotorTypeData,
  TypeData,
} from 'src/utils/interfaces/rotor-type.interfaces';
import { RotorTypeDataAdapter } from './rotor-type-data.adapter';

export class TypeDataModel implements TypeData {
  constructor(
    public readonly data: RotorTypeData,
    public readonly pictureId: string,
    public readonly attachments: (Attachment | string)[],
    public readonly machineAssetId?: string,
    public readonly laserLinesStatus?: LaserLinesStatus
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class TypeDataAdapter implements Adapter<RotorTypeFormsData, TypeData> {
  private readonly rotorTypeDataAdapter = inject(RotorTypeDataAdapter);

  /**
   * Creates the adapted form data
   *
   * @param formData: RotorTypeFormsData
   * @param units: UnitsV2[]
   * @param status: string
   * @returns TypeData
   */
  adapt(
    formData: RotorTypeFormsData,
    units: UnitsV2[],
    status: string = RotorTypeStatuses.SetupMissing
  ): TypeData {
    return new TypeDataModel(
      this.rotorTypeDataAdapter.adapt(formData, units, status),
      this.getImage(formData.summaryStep.photo),
      this.getAttachments(formData.summaryStep.attachments),
      formData.summaryStep.selectedMachine ? formData.summaryStep.selectedMachine.assetId : null,
      formData.supportSettingsStep.laserLinesActive ? 'Enabled' : 'Disabled'
    );
  }

  private getAttachments(attachments: (Attachment | string)[]): string[] {
    if (!attachments?.length) {
      return [];
    }

    return (<Attachment[]>attachments)[0].id
      ? (<Attachment[]>attachments).map(({ id }) => id)
      : <string[]>attachments;
  }

  private getImage(image: string | string[]): string {
    if (!image) {
      return null;
    }

    return isArray(image) ? image[0] : image;
  }
}
